import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import * as Yup from "yup";
import { Table, DatePicker, Select } from "antd";
import { toast } from "core/Operations/toast";
import { importTimelogValidationSchema } from "core/Operations/ValidationSchema/attendanceValidationSchema";
import {
  useFormattedEmployees,
  useFormattedExcluedEmployeesOptions,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import AlertMessage from "Components/UI/AlertMessage";
const { RangePicker } = DatePicker;
import { format, parseISO, parse, isValid, set } from "date-fns";
import { useGetGeneratedContractQuery } from "AppQuries/master/ContractTemplate/contract-template";

const excelEpoch = new Date(Date.UTC(1899, 11, 30));


const EmployeeContract = () => {
  const userData = useSelector(loggedInUser);
  const companyCode = userData?.companyCode;
  const [isMount, setIsMount] = useState(false);
  const navigate = useNavigate();
  const validationSchema = Yup.array().of(importTimelogValidationSchema);

  const employeeOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.locationCode,
    departmentCode: userData?.departmentCode,
  });
  const [filterData, setFilterData] = useState({
    companyCode: userData?.companyCode,
    employeeCode: 0,
  });

  const {
    data: contractData,
    isLoading,
    refetch: getContract,
    isError,
    error,
    isSuccess,
  } = useGetGeneratedContractQuery(filterData);

  const updateFilterData = (key, value) => {
    setFilterData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleGenerateContractForm = () => {
    getContract();
  };
  useEffect(() => {
    
    if (isSuccess && isMount) {
      if (contractData?.response === "Success") {
        toast.success("Contract form download started");
        const contractFormUrl = contractData?.reportURL;
        window.open(contractFormUrl, "_blank");
      }
      setIsMount(false); // reset after handling
    } else if (isError && isMount) {
      toast.error(error?.message || "Error generating Contract form");
      setIsMount(false);
    }
  }, [contractData, isSuccess, isError, error, isMount]);

  useEffect(() => {
    if (contractData?.response === "Success") {
      setIsMount(true);
    }
  }, [contractData]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Employee Contract</h4>
              <h6>Manage Employee Contracts</h6>
            </div>
          </div>

          {/* <div className="page-btn">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
            >
              <Link
                to={`${all_routes.attendance}${all_routes.time_log}`}
                className="btn btn-secondary"
              >
                
                Back
              </Link>
            </OverlayTrigger>
          </div> */}
        </div>
        <div className="card border-0">
          <div className="card-body">
            <div className="row form-row">
              <div className="col-md-6">
                <div className="form-floating">
                  <Select
                    placeholder="Select Employees"
                    className={`form-control`}
                    options={employeeOptions}
                    onChange={(selectedOptions) => {
                      console.log(selectedOptions);
                      updateFilterData("employeeCode", selectedOptions);
                    }}
                    showSearch
                    allowClear
                    updateFilterData={() => {
                      updateFilterData("employeeCode", 0);
                    }}
                    style={{ width: "100%", height: "auto" }}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                  <label className="form-label">Employee</label>
                </div>
              </div>

              {filterData?.employeeCode ? (
                <>
                  <div className="col-lg-1 d-flex align-items-center">
                    <div className="d-grid align-items-center  mb-3">
                      <button
                        onClick={handleGenerateContractForm}
                        // onClick={() => generateExcel({ optionData })}
                        className="btn btn-submit"
                        type="button"
                      >
                        Download
                      </button>
                    </div>
                  </div>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {/* {filterData?.employeeCode && (
                    <div className="col-lg-1 d-flex align-items-center justify-content-end">
                      <div className="d-grid align-items-center  mb-3">
                        <Link
                          to={`${all_routes.fill_ket_information}/${filterData?.employeeCode}`}
                          // onClick={() => generateExcel({ optionData })}
                          className="btn btn-submit"
                          // type="button"
                        >
                          Generate
                        </Link>
                      </div>
                    </div>
                  )} */}
                </>
              ) : (
                ""
              )}
            </div>
            {filterData?.employeeCode ? (
              ""
            ) : (
              <div className="row">
                <hr />
                <div className="col-md-12">
                  <AlertMessage
                    message="Please select employee"
                    type="danger"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeContract;
